import { render } from "./Member.vue?vue&type=template&id=2af8ec4a"
import script from "./Member.vue?vue&type=script&lang=js"
export * from "./Member.vue?vue&type=script&lang=js"
script.render = render

export default script